// extracted by mini-css-extract-plugin
export default {"tag":"TagElement_tag__7cKUR"};